import Check from '../../../shared/assets/icons/redesign/check.svg';

export default function LoginPopupContent({ onClose, signupUrl, loginUrl }) {
  return (
    <>
      <div className="popup-header">
        <h4>Inloggen</h4>

        <button className="popup-close-button" onClick={onClose}>
          &times;
        </button>
      </div>

      <div className="popup-body">
        <ul className="popup-list">
          <li className="popup-list-item">
            <span className="popup-icon-wrap">
              <Check className="popup-icon" />
            </span>
            Beheer je eigen dossier
          </li>

          <li className="popup-list-item">
            <span className="popup-icon-wrap">
              <Check className="popup-icon" />
            </span>
            Direct online contact
          </li>

          <li className="popup-list-item">
            <span className="popup-icon-wrap">
              <Check className="popup-icon" />
            </span>
            Ontvang wekelijkse content op maat
          </li>
        </ul>

        <a
          rel="noopener noreferrer"
          className="popup-button popup-button-primary"
          href={loginUrl}
        >
          Inloggen
        </a>

        <p className="popup-text">
          Heb je nog geen account?{' '}
          <a className="popup-link" rel="noopener noreferrer" href={signupUrl}>
            Registreren
          </a>
        </p>
      </div>
    </>
  );
}
